import { ShippingBox } from 'assets/icons';
import styles from './DispatchInfo.module.css';

export type DispatchInfoProps = {
  date: string;
};

export const DispatchInfo = ({ date }: DispatchInfoProps) => {
  return (
    <p className={styles.dispatchText}>
      <ShippingBox />
      {date}
    </p>
  );
};
